import { getInfoLogger, normalizeSlashChars } from '@ori/checkout-utils';
import { parseClientAppConfig } from '@ori/client-app-config';
import type { NonOptionalKeys } from '@ori/ts-utils';

import { APP_NAME } from '../constants';
import type { AppConfiguration, ParsedAppConfiguration } from '../types/AppConfiguration';

const logInfo = getInfoLogger(APP_NAME);

// Required props for parseSpaConfig method.
const requiredProps: Array<NonOptionalKeys<ParsedAppConfiguration>> = [
  'customerId',
  'globalApiUrl',
  'identityUrl',
  'staticApiUrl',
];

/**
 * Normalizes some values in the raw parsed config.
 * @param parsedConfig Original config data returned by the parseSpaConfig method.
 * @returns Final normalized configuration.
 */
export const normalizeConfigData = (parsedConfig: ParsedAppConfiguration) => {
  // Temporary solution for local Online development (localApiUrl has value only if Online environment is local)
  const globalApiUrl =
    parsedConfig.localApiUrl && Boolean(parsedConfig.localApiUrl)
      ? parsedConfig.localApiUrl
      : parsedConfig.globalApiUrl;

  const result: AppConfiguration = {
    ...parsedConfig,
    globalApiUrl: normalizeSlashChars(globalApiUrl, false, false),
    graphqlUrl: normalizeSlashChars(parsedConfig.graphqlUrl ?? '', false, false),
    identityUrl: normalizeSlashChars(parsedConfig.identityUrl, false, false),
    staticApiUrl: normalizeSlashChars(parsedConfig.staticApiUrl, false, false),
  };

  return result;
};

/**
 * Parses the configuration for subscription wizard SPA component.
 * @param config Subscription wizard SPA root element.
 * @returns Subscription wizard component configuration.
 */
export const getConfiguration = (config: string) => {
  const parsedConfig = parseClientAppConfig<ParsedAppConfiguration>(config, requiredProps);
  const result = normalizeConfigData(parsedConfig);
  logInfo('getConfiguration', result);

  return result;
};
